import { JSX } from 'react'

import { IconProps } from '../../icon'

const STEAM: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 100 20'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_667_20)'>
      <path
        d='M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z'
        fill='#68B765'
      />
      <path
        d='M7.1 12.73C7.75 12.73 8.59 13.39 9.93 13.39C10.95 13.39 11.32 12.87 11.32 12.31C11.32 11.44 10.32 11.26 8.83 10.77C7.47 10.33 6.06 9.74997 6.06 7.65997C6.06 5.14997 8.01999 3.96997 10.2 3.96997C12.3 3.96997 13.47 4.69997 13.47 5.69997C13.47 6.40997 13 6.92997 12.31 6.92997C11.47 6.92997 11.19 6.48997 10.08 6.48997C9.37 6.48997 8.88 6.85997 8.88 7.42997C8.88 8.08997 9.53 8.16997 11.34 8.76997C12.76 9.23997 14.14 9.96997 14.14 12.15C14.14 14.8 12.18 16 9.74 16C8.2 16 5.87 15.4 5.87 14.11C5.87 13.41 6.3 12.73 7.1 12.73Z'
        fill='white'
      />
      <path
        d='M30 20C35.5228 20 40 15.5228 40 10C40 4.47715 35.5228 0 30 0C24.4772 0 20 4.47715 20 10C20 15.5228 24.4772 20 30 20Z'
        fill='#D53259'
      />
      <path
        d='M28.69 6.62001H27.22C26.35 6.62001 25.86 6.13001 25.86 5.41001C25.86 4.65001 26.34 4.20001 27.22 4.20001H32.78C33.65 4.20001 34.14 4.65001 34.14 5.41001C34.14 6.14001 33.65 6.62001 32.78 6.62001H31.31V14.42C31.31 15.34 30.76 15.81 30 15.81C29.24 15.81 28.69 15.34 28.69 14.42V6.62001Z'
        fill='white'
      />
      <path
        d='M50 20C55.5228 20 60 15.5228 60 10C60 4.47715 55.5228 0 50 0C44.4772 0 40 4.47715 40 10C40 15.5228 44.4772 20 50 20Z'
        fill='#008FC8'
      />
      <path
        d='M46.64 5.54999C46.64 4.70999 47.27 4.23999 47.95 4.23999H51.96C52.79 4.23999 53.27 4.72999 53.27 5.44999C53.27 6.20999 52.78 6.65999 51.96 6.65999H49.26V8.74999H51.74C52.57 8.74999 53.05 9.21999 53.05 9.95999C53.05 10.7 52.56 11.17 51.74 11.17H49.26V13.32H52.06C52.89 13.32 53.37 13.77 53.37 14.53C53.37 15.26 52.88 15.74 52.06 15.74H47.95C47.27 15.74 46.64 15.27 46.64 14.43V5.54999Z'
        fill='white'
      />
      <path
        d='M70 20C75.5228 20 80 15.5228 80 10C80 4.47715 75.5228 0 70 0C64.4772 0 60 4.47715 60 10C60 15.5228 64.4772 20 70 20Z'
        fill='#954B97'
      />
      <path
        d='M67.8 6.44C68.27 5.16 68.67 4.06 69.98 4.06C71.32 4.06 71.73 5.16 72.2 6.44L74.72 13.25C75.06 14.17 75.11 14.48 75.11 14.87C75.11 15.52 74.59 15.94 73.85 15.94C72.99 15.94 72.72 15.39 72.47 14.66L72.15 13.62H67.85L67.53 14.66C67.29 15.39 67.01 15.94 66.15 15.94C65.41 15.94 64.89 15.52 64.89 14.87C64.89 14.48 64.94 14.17 65.28 13.25L67.8 6.44ZM70.06 6.97H70.03L68.62 11.19H71.37L70.06 6.97Z'
        fill='white'
      />
      <path
        d='M90 20C95.5228 20 100 15.5228 100 10C100 4.47715 95.5228 0 90 0C84.4772 0 80 4.47715 80 10C80 15.5228 84.4772 20 90 20Z'
        fill='#F5A04C'
      />
      <path
        d='M84.71 5.79001C84.95 4.42001 85.78 4.14001 86.44 4.14001C87.75 4.14001 88.04 4.90001 88.71 6.97001L89.99 10.93H90.02L91.3 6.97001C91.96 4.90001 92.25 4.14001 93.56 4.14001C94.22 4.14001 95.05 4.42001 95.29 5.79001L96.33 11.71C96.54 12.91 96.77 14.22 96.77 14.61C96.77 15.19 96.32 15.86 95.54 15.86C94.36 15.86 94.15 15.02 94.02 14.13L93.24 9.02001H93.2L91.44 14.68C91.18 15.52 90.79 15.86 90 15.86C89.21 15.86 88.82 15.52 88.56 14.68L86.8 9.01001H86.77L85.99 14.12C85.86 15.01 85.65 15.85 84.47 15.85C83.69 15.85 83.24 15.19 83.24 14.6C83.24 14.21 83.47 12.9 83.68 11.7L84.71 5.79001Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_667_20'>
        <rect width='100' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default STEAM
